import Tablesort from "tablesort";

const mobileMQ = window.matchMedia("(max-width: 768px)");

export class Table {
  private element: HTMLElement;
  private tableElement: HTMLTableElement;
  private mobileOnly: boolean = false;

  constructor(element: HTMLElement) {
    if (!!element) {
      this.element = element;

      this.tableElement = this.element.querySelector(
        "table",
      ) as HTMLTableElement;
      this.mobileOnly = element.dataset.mobileOnly === "true";
      this.init();
    }
  }

  private init() {
    if (this.mobileOnly) {
      this.handleResize();
      this.handleMobileOnly();
    } else {
      this.initializeTableSorter();
    }
  }

  private handleResize() {
    const resize = () => {
      this.handleMobileOnly();
    };
    mobileMQ.addEventListener("change", resize);
    if (!mobileMQ.matches) {
      resize();
    }
  }

  private initializeTableSorter() {
    new Tablesort(this.tableElement);
    const headers = this.tableElement.querySelectorAll(
      "th[role='columnheader']",
    );
    headers.forEach((header) => header.removeAttribute("role"));
    const firstHeader = this.tableElement.querySelector("th");
    if (firstHeader) {
      firstHeader.click();
    }
  }

  private handleMobileOnly() {}
}

export default function tableInit() {
  const table = document.querySelectorAll(".table") as NodeListOf<HTMLElement>;
  for (let i = 0; i < table.length; i++) {
    new Table(table[i]);
  }
}
